<template>
    <div :class="gapClass">
        <div :class="borderClass">
        </div>
    </div>
</template>
<script setup lang="ts">
   import { computed, ref } from "vue";
   const props = defineProps({
        vertical: {
            type: Boolean,
            default: false
        },
        gap:{
            type: Number,
            default: 2
        }
   });
   const borderClass = computed(() => {
        if(props.vertical){
            return `border-l`;
        }
        else{
            return `border-t`;
        }
   });
   const gapClass = computed(() => {
        if(props.vertical){
            return `px-${props.gap}`;
        }
        else{
            return `py-${props.gap}`;
        }
   });
</script>